export default "__VITE_ASSET__Bfi1CdCq__"